import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Tabs } from '../../components/Tabs/Tabs';
import { adminApprovalActions } from '../../redux/actions/adminApprovalActions';
import DetailTab from './DetailTab';
import MainTab from './MainTab';

const AdminApprovalPage = () => {
  const dispatch = useDispatch();
  const { activeTabKey, tabs } = useSelector(state => state.adminApproval);

  return (
    <div>
      <Tabs
        activeKey={activeTabKey}
        onClick={key => dispatch(adminApprovalActions.changeTab(key))}
      >
        <Tab title="Persetujuan Admin">
          <MainTab />
        </Tab>
        {tabs.map((row, key) =>
          <Tab
            key={row.key}
            title={row.title}
            isLoading={row.loading}
            onClose={() => dispatch(adminApprovalActions.closeTab(row.key))}
            onClick={() => dispatch(adminApprovalActions.changeTab(row.key))}
            active={activeTabKey === row.key}
          >
            <DetailTab index={key} />
          </Tab>
        )}
      </Tabs>
    </div>
  )
}

export default AdminApprovalPage
